
function SettlementManagement() {

  let settlementManagement = [
    {
      name: "Settlement Management",
      icon: "Settlement Management",
      logoName: "MyAccounts",
      // flag: "voucherRequired",
      displayService: "settlementmanagement",
      items: [],
    },
  ];

  const dashboard = () => {
    const dashboardArr = [
      {
        path: "/index/settlement-management",
        name: "Dashboard",
        icon: "dashboard",
        logoName: "dashboard",
        flag: "DASHBOARD",
      },
    ];

    return dashboardArr;
  };

  const merchantWireReport = () => {
    const profileArr = [
      {
        path: "/index/merchantWireReport",
        name: "Merchant Wire Report",
        icon: "Merchant Wire Report",
        logoName: "merchant wire report",
        flag: "MERCHANT WIRE REPORTS",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
    // ) {
    return profileArr;
    // } else {
    //   return "";
    // }
  };

  const manualSettlement = () => {
    const mybanksArr = [
      {
        path: "/index/manualSettlement",
        name: "Manual Settlement",
        icon: "Manual Settlement",
        logoName: "manual settlement ",
        flag: "MANUAL SETTLEMENTS",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mybanksArr[0].flag])
    // ) {
    return mybanksArr;
    // } else {
    //   return "";
    // }
  };

  const chargeMaster = () => {
    const mycardsArr = [
      {
        path: "/index/chargeMaster",
        name: "Charge Master",
        icon: "Charge Master",
        logoName: "charge master",
        flag: "CHARGE MASTER",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mycardsArr[0].flag])
    // ) {
    return mycardsArr;
    // } else {
    //   return "";
    // }
  };

  const voucherWireManager = () => {
    const mycardsArr = [
      {
        path: "/index/voucherWireManager",
        name: "Voucher Wire Manager",
        icon: "Voucher Wire Manager",
        logoName: "voucher management",
        flag: "VOUCHER MASTER",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mycardsArr[0].flag])
    // ) {
    return mycardsArr;
    // } else {
    //   return "";
    // }
  };

  const generateMerchantWireReport = () => {
    const mycardsArr = [
      {
        path: "/index/generateMerchantWireReport",
        name: "Generate Merchant Wire Report",
        icon: "Generate Merchant Wire Report",
        logoName: "generate merchant",
        flag: "GENERATE MERCHANT WIRE REPORT",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mycardsArr[0].flag])
    // ) {
    return mycardsArr;
    // } else {
    //   return "";
    // }
  };

  let a = dashboard();
  let b = merchantWireReport();
  let c = manualSettlement();
  let d = chargeMaster();
  let e = voucherWireManager()
  let f = generateMerchantWireReport()

  // settlementManagement[0].items = [...a, ...b, ...c, ...d, ...e];

  settlementManagement[0].items = [...a, ...b, ...c, ...d, ...e, ...f];

  return settlementManagement;
}

export default SettlementManagement;
